import styled from "@emotion/styled";
import { FontWeight, Spacing } from "@snapchat/snap-design-system";

export const MessagesText = styled.div`
    padding-top: ${Spacing.MD}px;
    padding-bottom: ${Spacing.MD}px;
`;

export const List = styled.ul`
    margin-top: ${Spacing.SM}px;
    margin-bottom: ${Spacing.SM}px;
`;

export const ListItem = styled.li`
    margin-left: 20px;

    &:not(:last-child) {
        margin-bottom: ${Spacing.XS}px;
    }
`;

export const BoldenText = styled.span`
    font-weight: ${FontWeight.MEDIUM};
`;
